module.exports = __webpack_public_path__ + "img/20.8b6ea64f.png";